// extracted by css-extract-rspack-plugin
export default {"fieldStack":"fieldStack-TclTwn"};